<template>
	<div class="row error-row w-100 px-0 mx-0" v-if="canShowErrorMessage" >
		<div class="col-md-12 mx-0 px-0">
			<div class="alert alert-warning alert-dismissible" role="alert" v-if="canShowErrorMessage" style="margin-top:15px">
				<div id="error-message-container" v-html="error"></div>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'vuex'
	import store from '../store'

	export default {
		store,
		computed: {
			...mapState({
				error: state => state.error
			}),
			canShowErrorMessage (){
				if(this.error)
				{
					return true
				}

				return false
			}
		},
		watch: {
			error: function (error) {
				if(error !== '' && document.getElementById('error-message-container'))
				{
					$('html,body').animate({
						scrollTop: $("#error-message-container").offset().top},
					'slow')
				}
			}
		},
	}
</script>

<style lang="scss">
.error-row {
	margin-top: 12px;
}

#error-message-container {
	.alert {
		margin-bottom: 0px;

		ul {
			padding-left: 0px;
		}
	}
}
</style>
